<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px">
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="reimbursement">
        <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
          <el-form-item label="类型" prop="orderType">
            <el-select v-model="form.orderType" placeholder="请选择" clearable size="small">
              <el-option label="订货" :value="1"></el-option>
              <el-option label="积分" :value="3"></el-option>
              <el-option label="秒杀" :value="2"></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item label="快递名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入快递名称" />
          </el-form-item>
           <el-form-item label="快递编码" prop="code">
            <el-input v-model="form.code" placeholder="请输入快递编码" />
          </el-form-item>
          <el-form-item label="付款方式" prop="paymentMethod">
            <el-radio-group v-model="form.paymentMethod">
              <el-radio :label="1">系统收费</el-radio>
              <el-radio :label="2">到付</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="包邮条件" v-if="form.paymentMethod === 1 && form.orderType != 3">
            <el-input v-model="form.freeMinAmount" placeholder="请输入包邮条件">
              <i slot="suffix" class="el-input__icon">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="邮费" prop="price" v-if="form.paymentMethod === 1">
            <el-input v-model="form.price" placeholder="请输入邮费">
              <i slot="suffix" class="el-input__icon">元</i>
            </el-input>
          </el-form-item>
          <el-form-item label="偏远地区" v-if="form.paymentMethod === 1">
            <div class="table-list mt20">
              <div class="spec-head">
                <div class="sp-col">地区</div>
                <div class="sp-col">包邮条件</div>
                <div class="sp-col">邮费</div>
                <div class="sp-col">操作</div>
              </div>
              <div class="spec-item" v-for="(item, idx) in form.regionFeeList" :key="idx">
                <el-form-item class="sp-col" :prop="`regionFeeList[${idx}].regionsList`" label-width="0" :rules="{required: false,message: '请选择',trigger: 'change'}">
                  <el-cascader :props="cascaderProps" collapse-tags v-model="item.regionsList" :options="regionOptions" clearable></el-cascader>
                </el-form-item>
                <el-form-item class="sp-col" :prop="`regionFeeList[${idx}].freeMinAmount`" label-width="0" :rules="{required: false,message: '请填写',trigger: 'change',}">
                  <el-input v-model="item.freeMinAmount" placeholder="请输入包邮条件" />
                </el-form-item>
                <el-form-item class="sp-col" :prop="`regionFeeList[${idx}].price`" label-width="0" :rules="{required: false,message: '请填写',trigger: 'change',}">
                  <el-input v-model="item.price" placeholder="请输入邮费" />
                </el-form-item>
                <div class="sp-col oper-icon">
                  <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.regionFeeList.length > 1"></i>
                  <i class="el-icon-plus" @click="handleAddItem"></i>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="不发货地址">
            <el-cascader @change="changeCascader" :props="cascaderProps" collapse-tags v-model="form.noDeliveryRegionsList  " :options="regionOptions" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="form.remark" placeholder="请输入描述" />
          </el-form-item>
          <el-form-item label="状态">
            <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">
            取消
          </el-button>
          <el-button type="primary" @click="doCreate()">
            确认
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import sysExpressApi from '@/api/config/sysExpress'
function initFormBean() {
  const formBean = {
    orderType: null,
    name: null,
    code: null,
    paymentMethod: null,
    freeMinAmount: null,
    price: null,
    regionFeeList: [{ regionsList: '', freeMinAmount: '', price: '' }],
    noDeliveryRegionsList: [],
    remark: null,
    isEnable: false,
    orderNo: 0
  }
  return formBean
}

export default {
  components: {},
  data() {
    return {
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        multiple: true
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        orderType: [{ required: true, message: '请选择类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入快递名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入快递编码', trigger: 'blur' }],
        paymentMethod: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
        price: [{ required: true, message: '请输入邮费', trigger: 'blur' }],
      },
      regionOptions: []
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 300;
    let regionOptions = JSON.parse(localStorage.getItem('addressTree')) || [];
    this.regionOptions = this.formatCascaderData(regionOptions)
  },
  methods: {
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    changeCascader() {
      let aa = this.form.noDeliveryRegionsList.map(i => {
        return { provinceCode: i[0], cityCode: i[1], districtCode: i[2] }
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      let arr = []
      if (row.noDeliveryRegions) {
        let noDeliveryRegions = JSON.parse(row.noDeliveryRegions)
        noDeliveryRegions.forEach(item => {
          arr.push([item.provinceCode, item.cityCode, item.districtCode])
        })
      }
      this.$set(this.form, 'noDeliveryRegionsList', arr)
      if (row.regionFeeList && row.regionFeeList.length > 0) {
        row.regionFeeList.forEach(item => {
          let newR = []
          if (item.regions) {
            let newRegions = JSON.parse(item.regions)
            newRegions && newRegions.forEach(itt => {
              newR.push([itt.provinceCode, itt.cityCode, itt.districtCode])
            })
          }
          item.regionsList = newR
        })
      } else {
        this.$set(this.form, 'regionFeeList', [{ regionsList: '', freeMinAmount: '', price: '' }])
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.noDeliveryRegionsList = params.noDeliveryRegionsList.length > 0 ? params.noDeliveryRegionsList.map(i => {
        return { provinceCode: i[0], cityCode: i[1], districtCode: i[2] }
      }) : null
      params.regionFeeList.forEach(item => {
        item.regionsList = item.regionsList.length > 0 ? item.regionsList.map(i => {
          return { provinceCode: i[0], cityCode: i[1], districtCode: i[2] }
        }) : []
      })
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams();
          params.regionFeeList.forEach((item, index) => {
            if (item.regionsList && !item.regionsList.length) params.regionFeeList.splice(index, 1)
          })
          if (params.paymentMethod === 2) {
            params.regionFeeList = null
          }
          if (params.orderType === 3) {
            params.freeMinAmount = 0
          }
          this.submitData(params)
        }
      });
    },
    submitData(params) {
      if (params.id > 0) {
        sysExpressApi.update(params).then((data) => {
          this.postCallback(data)
        });
      } else {
        sysExpressApi.create(params).then((data) => {
          this.postCallback(data)
        });
      }
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.regionFeeList.splice(index, 1)
    },
    handleAddItem() {
      this.form.regionFeeList.push({ regionsList: '', freeMinAmount: '', price: '' })
    }
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}

::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.full-box {
  display: flex;
  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;
    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
</style>

